
  $(document).ready(function() {
    $('.show-phone-button').click(function() {
      $('.phone').toggle();
    });
  });
  